import { render, staticRenderFns } from "./InvoiceNotFound.vue?vue&type=template&id=47adff9a"
import script from "./InvoiceNotFound.vue?vue&type=script&lang=js"
export * from "./InvoiceNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports